import { useContext } from 'react';
import i18n from '../utilities/i18n';
import { ConfigContext } from './ConfigProvider';
import Button from '@material-ui/core/Button';
import { useFeatures } from 'flagged';

export const TextAndLanguageProvider = ({ children }) => {
    const { CustomerConfig } = useContext(ConfigContext);
    const features = useFeatures();

    return (
        <>
            {features.multilingual && CustomerConfig.SupportedLanguages ?
            (
                <div className="languageButtonWrapper">
                {CustomerConfig.SupportedLanguages.map((lng) => (<Button key={lng} onClick={() => i18n.changeLanguage(lng)}><img className="languageButton" alt={lng} src={"/flag/" + lng + ".svg"} /></Button>))}
                </div>
            ) : null}
            {children}
        </>
    )
}

export const useTextAndLanguage = () => useContext(ConfigContext);